export class GetOrganizationLicensesRequest {
    includeNonLicensedUsers: boolean = false;;
}